import React, { useState } from "react";
import "./Charts.css"; // Ensure this CSS file exists

const Charts = () => {
    const [selectedChart, setSelectedChart] = useState(null);

    const charts = [
        { src: "/attacks_per_year.png", alt: "Attacks Per Year", title: "Attacks Per Year" },
        { src: "/weapons.png", alt: "Weapons Used in Attacks", title: "Weapons Used" },
        { src: "/country_victims.png", alt: "Country Victims", title: "Top Affected Countries" },
        { src: "/suspect_origins.png", alt: "Suspect Origins", title: "Top Suspect Origins" },
        { src: "/months.png", alt: "Attacks By Month", title: "Attacks By Month" },
        { src: "/attacks_per_year_europe.png", alt: "Attacks Per Year (Europe)", title: "Attacks Per Year (Europe)" },
        { src: "/europe_victims.png", alt: "Country Victims (Europe)", title: "Top Affected Countries (Europe)" },
        { src: "/europe_suspect_origins.png", alt: "Suspect Origins (Europe)", title: "Top Suspect Origins (Europe)" },
    ];

    // Close modal when clicking outside or pressing ESC
    const closeModal = () => setSelectedChart(null);

    return (
        <div className="charts-container">
            <div className="charts-grid">
                {charts.map((chart, index) => (
                    <div key={index} className="chart-card" onClick={() => setSelectedChart(chart)}>
                        <h2 className="chart-title">{chart.title}</h2>
                        <img src={chart.src} alt={chart.alt} className="chart-image" />
                    </div>
                ))}
            </div>

            {/* Modal for Enlarged Image */}
            {selectedChart && (
                <div className="chart-modal" onClick={closeModal}>
                    <div className="chart-modal-content">
                        <h2>{selectedChart.title}</h2>
                        <img src={selectedChart.src} alt={selectedChart.alt} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Charts;